import React, { useEffect, useState } from "react";
import "./AdminLogin.css";
import { useHistory } from "react-router-dom";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import CustomInput from "components/widgets/custom-input/CustomInput.js";
import CustomButton from "components/widgets/custom-button/CustomButton.js";
import { titles } from "constants/titles";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, isValidEmail } from "utility";
import { adminLogin } from "redux/AdminScreens/action";
import { bg_image } from "assets/images/images";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";
import Loader from "react-spinners/ClipLoader";
import alerts from "constants/alerts";

const AdminLogin = () => {
  const [loginState, setLoginState] = useState({
    email: "",
    password: "",
    device_token: "",
    isShowPassword: false,
  });

  // Field error state (like CustomerLogin)
  const [fieldErrors, setFieldErrors] = useState({
    email: false,
    password: false,
  });
  const [validationTriggered, setValidationTriggered] = useState(false);
  const { snackbarState, dismissSnackbar, onApiResponse } = useAdvancedValidation();

  const isLoading = useSelector((store) => store?.auth?.loading);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (action === 'POP') {
        history.replace(ROUTES_CONSTANTS?.landingScreen);
      }
    });

    return () => {
      unlisten();
    };
  }, [history]);

  const onLogin = async () => {
    setValidationTriggered(true);
    setFieldErrors({ email: false, password: false });
    // Validate fields (like CustomerLogin: check isEmpty AND isValidEmail for email)
    let hasErrors = false;
    if (isEmpty(loginState?.email) || !isValidEmail(loginState?.email)) {
      setFieldErrors(prev => ({ ...prev, email: true }));
      hasErrors = true;
    }
    if (isEmpty(loginState?.password)) {
      setFieldErrors(prev => ({ ...prev, password: true }));
      hasErrors = true;
    }

    if (hasErrors) {
      return;
    }

    let adminLoginPayload = await getLoginPayload();
    adminLogin(dispatch, adminLoginPayload, history, onApiResponse);
  };

  // required later
  const getLoginPayload = async () => {
    return {
      email: loginState?.email,
      password: loginState?.password,
    };
  };

  const onValueChange = (type, e) => {
    let newText = e?.target?.value;
    setLoginState((prev) => {
      return { ...prev, [type]: newText };
    });

    // Clear API errors when user starts typing (same as mobile)
    if (snackbarState?.show) {
      dismissSnackbar();
    }

    // Real-time validation after submit has been clicked (like CustomerLogin)
    if (validationTriggered) {
      if (type === 'email') {
        if (isEmpty(newText) || !isValidEmail(newText)) {
          setFieldErrors(prev => ({ ...prev, email: true }));
        } else {
          setFieldErrors(prev => ({ ...prev, email: false }));
        }
      } else if (type === 'password') {
        if (isEmpty(newText)) {
          setFieldErrors(prev => ({ ...prev, password: true }));
        } else {
          setFieldErrors(prev => ({ ...prev, password: false }));
        }
      }
    }
  };

  // Check if there are any validation errors
  const hasErrors = fieldErrors.email || fieldErrors.password;

  return (
    <div className="admin_main_layout">
      {isLoading ? (
        <div className="layout_loader_container">
          <Loader color={"#DB4E3B"} />
        </div>
      ) : null}
      <div className="admin_login_container">
        <div className="admin_login_background">
          <img
            src={bg_image}
            alt="background"
            className="admin_login_background_image"
          />
          <div className="admin_login_background_overlay"></div>
        </div>

        <div className="admin_login_content">
          <div className="admin_login_form">
            {/* API Error message above email (like mobile) */}
            {snackbarState?.show && (
              <div className="admin_login_api_error">
                <p className="admin_login_api_error_text">
                  {snackbarState?.message}
                </p>
              </div>
            )}

            <CustomInput
              label={titles?.email}
              placeholder={titles?.email}
              type="email"
              value={loginState?.email}
              labelClassName={"text-white-color"}
              className="admin_login_input"
              error={validationTriggered && fieldErrors?.email}
              errorMessage={validationTriggered && fieldErrors?.email ? alerts?.incorrect_details : ""}
              whiteError={true}
              onChange={(value) => {
                onValueChange("email", value);
              }}
            />
            <CustomInput
              label={titles?.password}
              placeholder={titles?.password}
              type="password"
              value={loginState?.password}
              labelClassName={"text-white-color"}
              className="admin_login_input"
              error={validationTriggered && fieldErrors?.password}
              errorMessage={validationTriggered && fieldErrors?.password ? alerts?.incorrect_details : ""}
              whiteError={true}
              onChange={(value) => {
                onValueChange("password", value);
              }}
            />
            <CustomButton
              text={titles?.login}
              width={"100%"}
              className={'white_button'}
              onClick={() => onLogin()}
              disabled={hasErrors}
              showErrorMessage={hasErrors}
              whiteError={true}
            />
            {/* <Link className="web_link" to={ROUTES_CONSTANTS.forgotPassword}>
              {titles?.forgot_password}
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
